"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var themes_industrial_1 = __importDefault(require("@uxd/themes-industrial"));
exports.IndustrialLayout = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: styles_1.createMuiTheme(themes_industrial_1.default) }, children));
};
//# sourceMappingURL=IndustrialLayout.js.map